import SrDocumentActivityForm from '../forms/SrDocumentActivityForm'
import {
  clearSrDocumentActivityAction,
  clearSrDocumentActivityErrors,
  updateSrDocumentActivity,
} from 'actions/srDocuments/srDocumentActivityActions'
import { fetchSrDocumentLocations } from 'actions/srDocuments/srDocumentLocationActions'
import { fetchSrDocumentStatuses } from 'actions/srDocuments/srDocumentStatusActions'
import _ from 'lodash'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

const SrDocumentActivityUpdate = ({
  formId,
  params,
  setParams,
  selected,
  setSelected,
  closeModal,
}) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { lastAction, activityErrors } = useSelector(
    (state) => state.srDocumentActivities
  )
  const statusOptions = useSelector(
    (state) => state.srDocumentStatuses.statusOptions
  )
  const locationOptions = useSelector(
    (state) => state.srDocumentLocations.locationOptions
  )

  //// LOCAL STATE.
  const [occurDate, setOccurDate] = useState(moment())
  const [occurTime, setOccurTime] = useState(moment())

  //// LIFECYCLE HELPERS.
  const selectedSize = _.size(selected)

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    if (selectedSize) {
      dispatch(
        fetchSrDocumentStatuses('form', selected.sr_document_status, true)
      )
      dispatch(
        fetchSrDocumentLocations('form', selected.sr_document_location, true)
      )
    }
    return () => {
      dispatch(clearSrDocumentActivityAction())
      dispatch(clearSrDocumentActivityErrors())
    }
  }, [
    dispatch,
    selectedSize,
    selected.sr_document_status,
    selected.sr_document_location,
  ])

  useEffect(() => {
    if (
      _.isEmpty(params) &&
      (Array.isArray(statusOptions) || statusOptions.length) &&
      (Array.isArray(locationOptions) || locationOptions.length)
    ) {
      const utcTime = moment
        .utc(selected.activity_occurred_at)
        .format('YYYY-MM-DD HH:mm:ssZ')
      const localTime = moment(utcTime, 'YYYY-MM-DD HH:mm:ssZ').local()
      setOccurDate(localTime)
      setOccurTime(localTime)
      setParams({
        id: selected.id,
        sr_document_status_id: selected.sr_document_status.id || 0,
        sr_document_location_id: selected.sr_document_location.id,
        comment: selected.comment,
        activity_occurred_at: selected.activity_occurred_at,
      })
      setSelected({
        ...selected,
        id: selected.id,
        customer_id: selected.customer_id,
      })
    }
  }, [
    selected,
    setSelected,
    params,
    setParams,
    setOccurDate,
    setOccurTime,
    statusOptions,
    locationOptions,
  ])

  // watch for success
  useEffect(() => {
    if (lastAction === 'edit') {
      closeModal()
    }
  }, [lastAction, closeModal])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()

        dispatch(updateSrDocumentActivity(params, selected))
      }}
      className="form container"
      noValidate
    >
      <SrDocumentActivityForm
        params={params}
        setParams={setParams}
        selected={selected}
        setSelected={setSelected}
        statusOptions={statusOptions}
        locationOptions={locationOptions}
        occurDate={occurDate}
        setOccurDate={setOccurDate}
        occurTime={occurTime}
        setOccurTime={setOccurTime}
        errors={activityErrors}
      />
    </form>
  )
}

export default SrDocumentActivityUpdate
